import { WorkflowTrigger, WorkflowTriggerName } from '@frontend/workflow/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum ColliTriggerName {
    COLLI_PROCESS = 'colli_process',
    COLLI_CANCEL = 'colli_cancel',
    PACKAGE_AUTOMATICALLY_PICKED_UP = 'package_automatically_picked_up',
    COLLI_COMPLETE = 'colli_complete',
    COLLI_STATE_CHANGED = 'colli_state_changed',
    COLLI_PACKAGE_PROCESSED = 'colli_package_processed',
    COLLI_PACKAGE_CANCELLED = 'colli_package_cancelled',
    COLLI_PACKAGE_FAILED = 'colli_package_failed',
    COLLI_PROCESSED = 'colli_processed',
    COLLI_PROCESSED_WITH_FAILURES = 'colli_processed_with_failures',
    COLLI_CANCELLED = 'colli_cancelled',
    COLLI_FAILED = 'colli_failed',
    COLLI_PIN_CODE_CREATED = 'colli_pin_code_created',
    COLLI_PIN_CODE_ENTERED = 'colli_pin_code_entered',
    COLLI_CODE_SCANNED = 'colli_code_scanned',
    COLLI_MOVE_SLOT = 'colli_move_slot',
    COLLI_SLOT_MOVED = 'colli_slot_moved',
    COLLI_SPOT_MOVED = 'colli_spot_moved',
    COLLI_DROPPED_OFF = 'colli_dropped_off',
    COLLI_PICKED_UP = 'colli_picked_up',
    COLLI_DROP_OFF = 'colli_drop_off',
    COLLI_PICK_UP = 'colli_pick_up',
    COLLI_LOST = 'colli_lost',
    COLLI_UPDATE_CURRENT_LOCATION = 'colli_update_current_location',
    COLLI_CURRENT_LOCATION_UPDATED = 'colli_current_location_updated'
}

export class ColliTrigger extends WorkflowTrigger {
    static readonly COLLI_PROCESS = new ColliTrigger(
        ColliTriggerName.COLLI_PROCESS,
        (
            <FormattedMessage
                id='ColliTrigger.process'
                description='The displayed value for the ColliTrigger process'
                defaultMessage='Colli process'
            />
        )
    );
    static readonly COLLI_CANCEL = new ColliTrigger(
        ColliTriggerName.COLLI_CANCEL,
        (
            <FormattedMessage
                id='ColliTrigger.cancel'
                description='The displayed value for the ColliTrigger cancel'
                defaultMessage='Colli cancel'
            />
        )
    );
    static readonly PACKAGE_AUTOMATICALLY_PICKED_UP = new ColliTrigger(
        ColliTriggerName.PACKAGE_AUTOMATICALLY_PICKED_UP,
        (
            <FormattedMessage
                id='ColliTrigger.package_automatically_picked_up'
                description='The displayed value for the ColliTrigger package_automatically_picked_up'
                defaultMessage='Package automatically picked up'
            />
        )
    );
    static readonly COLLI_COMPLETE = new ColliTrigger(
        ColliTriggerName.COLLI_COMPLETE,
        (
            <FormattedMessage
                id='ColliTrigger.complete'
                description='The displayed value for the ColliTrigger complete'
                defaultMessage='Colli complete'
            />
        )
    );
    static readonly COLLI_STATE_CHANGED = new ColliTrigger(
        ColliTriggerName.COLLI_STATE_CHANGED,
        (
            <FormattedMessage
                id='ColliTrigger.state_changed'
                description='The displayed value for the ColliTrigger state_changed'
                defaultMessage='Colli state changed'
            />
        )
    );
    static readonly COLLI_PACKAGE_PROCESSED = new ColliTrigger(
        ColliTriggerName.COLLI_PACKAGE_PROCESSED,
        (
            <FormattedMessage
                id='ColliTrigger.package_processed'
                description='The displayed value for the ColliTrigger package_processed'
                defaultMessage='Colli package processed'
            />
        )
    );
    static readonly COLLI_PACKAGE_CANCELLED = new ColliTrigger(
        ColliTriggerName.COLLI_PACKAGE_CANCELLED,
        (
            <FormattedMessage
                id='ColliTrigger.package_cancelled'
                description='The displayed value for the ColliTrigger package_cancelled'
                defaultMessage='Colli package cancelled'
            />
        )
    );
    static readonly COLLI_PACKAGE_FAILED = new ColliTrigger(
        ColliTriggerName.COLLI_PACKAGE_FAILED,
        (
            <FormattedMessage
                id='ColliTrigger.package_failed'
                description='The displayed value for the ColliTrigger package_failed'
                defaultMessage='Colli package failed'
            />
        )
    );
    static readonly COLLI_PROCESSED = new ColliTrigger(
        ColliTriggerName.COLLI_PROCESSED,
        (
            <FormattedMessage
                id='ColliTrigger.processed'
                description='The displayed value for the ColliTrigger processed'
                defaultMessage='Colli processed'
            />
        )
    );
    static readonly COLLI_PROCESSED_WITH_FAILURES = new ColliTrigger(
        ColliTriggerName.COLLI_PROCESSED_WITH_FAILURES,
        (
            <FormattedMessage
                id='ColliTrigger.processed_with_failures'
                description='The displayed value for the ColliTrigger processed_with_failures'
                defaultMessage='Colli processed with failures'
            />
        )
    );
    static readonly COLLI_CANCELLED = new ColliTrigger(
        ColliTriggerName.COLLI_CANCELLED,
        (
            <FormattedMessage
                id='ColliTrigger.cancelled'
                description='The displayed value for the ColliTrigger cancelled'
                defaultMessage='Colli cancelled'
            />
        )
    );
    static readonly COLLI_FAILED = new ColliTrigger(
        ColliTriggerName.COLLI_FAILED,
        (
            <FormattedMessage
                id='ColliTrigger.failed'
                description='The displayed value for the ColliTrigger failed'
                defaultMessage='Colli failed'
            />
        )
    );
    static readonly COLLI_PIN_CODE_CREATED = new ColliTrigger(
        ColliTriggerName.COLLI_PIN_CODE_CREATED,
        (
            <FormattedMessage
                id='ColliTrigger.pin_code_created'
                description='The displayed value for the ColliTrigger pin_code_created'
                defaultMessage='Colli PIN-code created'
            />
        )
    );
    static readonly COLLI_PIN_CODE_ENTERED = new ColliTrigger(
        ColliTriggerName.COLLI_PIN_CODE_ENTERED,
        (
            <FormattedMessage
                id='ColliTrigger.pin_code_entered'
                description='The displayed value for the ColliTrigger pin_code_entered'
                defaultMessage='Colli PIN-code entered'
            />
        )
    );
    static readonly COLLI_CODE_SCANNED = new ColliTrigger(
        ColliTriggerName.COLLI_CODE_SCANNED,
        (
            <FormattedMessage
                id='ColliTrigger.code_scanned'
                description='The displayed value for the ColliTrigger code_scanned'
                defaultMessage='Colli code scanned'
            />
        )
    );
    static readonly COLLI_MOVE_SLOT = new ColliTrigger(
        ColliTriggerName.COLLI_MOVE_SLOT,
        (
            <FormattedMessage
                id='ColliTrigger.move_slot'
                description='The displayed value for the ColliTrigger move_slot'
                defaultMessage='Colli move SLOT'
            />
        )
    );
    static readonly COLLI_SLOT_MOVED = new ColliTrigger(
        ColliTriggerName.COLLI_SLOT_MOVED,
        (
            <FormattedMessage
                id='ColliTrigger.slot_moved'
                description='The displayed value for the ColliTrigger slot_moved'
                defaultMessage='Colli SLOT moved'
            />
        )
    );
    static readonly COLLI_SPOT_MOVED = new ColliTrigger(
        ColliTriggerName.COLLI_SPOT_MOVED,
        (
            <FormattedMessage
                id='ColliTrigger.spot_moved'
                description='The displayed value for the ColliTrigger spot_moved'
                defaultMessage='Colli SPOT moved'
            />
        )
    );
    static readonly COLLI_DROPPED_OFF = new ColliTrigger(
        ColliTriggerName.COLLI_DROPPED_OFF,
        (
            <FormattedMessage
                id='ColliTrigger.dropped_off'
                description='The displayed value for the ColliTrigger dropped_off'
                defaultMessage='Colli dropped off'
            />
        )
    );
    static readonly COLLI_PICKED_UP = new ColliTrigger(
        ColliTriggerName.COLLI_PICKED_UP,
        (
            <FormattedMessage
                id='ColliTrigger.picked_up'
                description='The displayed value for the ColliTrigger picked_up'
                defaultMessage='Colli picked up'
            />
        )
    );
    static readonly COLLI_DROP_OFF = new ColliTrigger(
        ColliTriggerName.COLLI_DROP_OFF,
        (
            <FormattedMessage
                id='ColliTrigger.drop_off'
                description='The displayed value for the ColliTrigger drop_off'
                defaultMessage='Colli drop-off'
            />
        )
    );
    static readonly COLLI_PICK_UP = new ColliTrigger(
        ColliTriggerName.COLLI_PICK_UP,
        (
            <FormattedMessage
                id='ColliTrigger.pick_up'
                description='The displayed value for the ColliTrigger pick_up'
                defaultMessage='Colli pick-up'
            />
        )
    );
    static readonly COLLI_LOST = new ColliTrigger(
        ColliTriggerName.COLLI_LOST,
        (
            <FormattedMessage
                id='ColliTrigger.lost'
                description='The displayed value for the ColliTrigger lost'
                defaultMessage='Colli lost'
            />
        )
    );
    static readonly COLLI_UPDATE_CURRENT_LOCATION = new ColliTrigger(
        ColliTriggerName.COLLI_UPDATE_CURRENT_LOCATION,
        (
            <FormattedMessage
                id='ColliTrigger.update_current_location'
                description='The displayed value for the ColliTrigger update_current_location'
                defaultMessage='Colli update current location'
            />
        )
    );
    static readonly COLLI_CURRENT_LOCATION_UPDATED = new ColliTrigger(
        ColliTriggerName.COLLI_CURRENT_LOCATION_UPDATED,
        (
            <FormattedMessage
                id='ColliTrigger.current_location_updated'
                description='The displayed value for the ColliTrigger current_location_updated'
                defaultMessage='Colli current location updated'
            />
        )
    );

    static override readonly ALL = [
        ColliTrigger.COLLI_PROCESS,
        ColliTrigger.COLLI_CANCEL,
        ColliTrigger.COLLI_COMPLETE,
        ColliTrigger.COLLI_STATE_CHANGED,
        ColliTrigger.COLLI_PACKAGE_PROCESSED,
        ColliTrigger.COLLI_PACKAGE_CANCELLED,
        ColliTrigger.COLLI_PACKAGE_FAILED,
        ColliTrigger.COLLI_PROCESSED,
        ColliTrigger.COLLI_PROCESSED_WITH_FAILURES,
        ColliTrigger.COLLI_CANCELLED,
        ColliTrigger.COLLI_FAILED,
        ColliTrigger.COLLI_PIN_CODE_CREATED,
        ColliTrigger.COLLI_PIN_CODE_ENTERED,
        ColliTrigger.COLLI_CODE_SCANNED,
        ColliTrigger.COLLI_MOVE_SLOT,
        ColliTrigger.COLLI_SLOT_MOVED,
        ColliTrigger.COLLI_SPOT_MOVED,
        ColliTrigger.COLLI_DROPPED_OFF,
        ColliTrigger.COLLI_PICKED_UP,
        ColliTrigger.COLLI_DROP_OFF,
        ColliTrigger.COLLI_PICK_UP,
        ColliTrigger.COLLI_LOST,
        ColliTrigger.COLLI_UPDATE_CURRENT_LOCATION,
        ColliTrigger.COLLI_CURRENT_LOCATION_UPDATED,
        ...super.ALL
    ];

    static override getByValue(trigger: ColliTriggerName | WorkflowTriggerName): WorkflowTrigger | undefined {
        return this.ALL.find((t) => t.value === trigger);
    }
}
